export const initialState = {
  ressourcenPlan: {},
  isLoading: false,
}

export default function ressourcen(state = initialState) {
  return state
}
